
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MbReport01Dialog extends Serenity.EntityDialog<MbReport01Row, any> {
        protected getFormKey() { return MbReport01Form.formKey; }
        protected getIdProperty() { return MbReport01Row.idProperty; }
        protected getLocalTextPrefix() { return MbReport01Row.localTextPrefix; }
        protected getNameProperty() { return MbReport01Row.nameProperty; }
        protected getService() { return MbReport01Service.baseUrl; }
        protected getDeletePermission() { return MbReport01Row.deletePermission; }
        protected getInsertPermission() { return MbReport01Row.insertPermission; }
        protected getUpdatePermission() { return MbReport01Row.updatePermission; }

        protected form = new MbReport01Form(this.idPrefix);
        constructor() {
            super();
            this.form = new MbReport01Form(this.idPrefix);
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
            let self = this;
            //ui-state-default slick-footerrow-column l0 r0 frozen
            self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });}
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}